import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'
import AuiDialog from '../../assets/js/aui-dialog'
import md5 from 'md5'
import sha256 from 'sha256'
/**
 * 获取设备列表
 * @param {*String} options.projectId 项目id
 * @param {String} options.statusType 状态查询的条件
 *                 [onLine(在线), offLine(离线), switchOn(亮灯), switchOff(关灯), alert(告警)]
 * @param {*String} options.name 按设备名称模糊查询的条件
 * @param {*String} options.pageNo 当前页
 */
const getAllDevices = async (option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  let {projectId, statusType, name, pageNo} = option
  let pageSize = 300
  return axios.get(`/api/v2/solar-motes/pagi?projectId=${projectId}&statusType=${statusType}&name=${name}&isDisabled=${true}&pageNo=${pageNo}&pageSize=${pageSize}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 删除设备
 * @param {*String} deviceID
 */
const deleteDevice = async (deviceId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.delete(`/api/v2/solar-motes/quick-unactivated/${deviceId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取设备信息和状态
 * @param {*String} deviceId 设备id
 */
const getDeviceStatusInfor = async (deviceId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/solar-motes/get-info-and-status/${deviceId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取设备当前应用的策略信息
 * @param {*String} deviceId 设备id
 */
const getDeviceStrategyInfor = async (deviceId, type) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  let isDouble = false
  if (type === '8' || type === '9') isDouble = true
  console.log('type', type)
  console.log('isDouble', isDouble)
  return axios.get(`/api/v2/solar-mote-strategys/solar-mote${isDouble ? '-list' : ''}/${deviceId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 修改设备
 * @param {*String} options.deviceId 设备id
 * @param {*String} options.name 设备名称
 * @param {*String} options.lng 设备经度
 * @param {*String} options.lat 设备纬度
 */
const updateDeviceInfor = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.put(`/api/v2/solar-motes/${options.deviceId}`, options)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取设备告警列表
 * @param {*String} options.deviceId 设备id
 * @param {*String} options.isRead 是否是已读
 * @param {*String} options.pageNo 当前页
 */
const getDeviceWarnsById = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/solar-motes/list-mote-alert/${options.deviceId}?isRead=${options.isRead}&pageNo=${options.pageNo}&pageSize=30`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 获取某日的单灯统计数据
 * @param {*String} deviceId 设备id
 * @param {*String} date 日期，示例 2018-01-25
 */
const getDeviceStatusById = async (deviceId, date) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/solar-mote-status-hiss/get-list/${deviceId}?date=${date}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取设备的简略信息（后面跟项目id）
 * @param {*String} projectId 分组id
 */
const getProjectDevicesBrief = async (projectId) => {
  return axios.get(`/api/v2/solar-motes/brief-group?projectId=${projectId}`, {})
    .then(res => {
      return res
    })
}
/**
 * 新增设备
 * @param {*String} options.projectId 所属项目id
 * @param {*String} options.name 设备名称
 * @param {*String} options.snHexadecimal 十六进制的sn号
 * @param {*String} options.pnHexadecimal 十六进制的pn号
 * @param {*Number} options.lng 经度
 * @param {*Number} options.lat 纬度
 * @param {*Number} options.paramSettingMode 参数设置模式,1-默认；2-自定义（如果电池电压选其他此参数值则为2-自定义，否则为1-默认）
 * @param {*Number} options.batteryType 电池类型（1-磷酸铁锂；2-三元锂；3-铅酸；）
 * @param {*Number} options.batteryVoltage 电池电压（如电池类型选中磷酸铁锂有12V，24V，其他）
 * @param {*Number} options.batteryOverVoltage 电池超压电压（用于充电停止电压），单位：V
 * @param {*Number} options.batteryOverToBackVoltage 电池超压恢复电压，单位：V
 * @param {*Number} options.batteryLowVoltage 电池低压电压（用于停止亮灯电压），单位：V
 * @param {*Number} options.batteryLowToBackVoltage 电池低压恢复电压，单位：V
 * @param {*Number} options.ledRatedCurrent LED灯额定电流，单位：A
 * @param {*Number} options.dayThreshold 光控天亮阈值，单位：V
 * @param {*Number} options.nightThreshold 光控天黑阈值，单位：V
 */
const addDevice = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/solar-motes/activated?projectId=${options.projectId}`, options)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 对设备下发参数
 * @param {*String} options.deviceId 设备id
 * @param {*Number} options.paramSettingMode 参数设置模式,1-默认；2-自定义（如果电池电压选其他此参数值则为2-自定义，否则为1-默认）
 * @param {*Number} options.batteryType 电池类型（1-磷酸铁锂；2-三元锂；3-铅酸；）
 * @param {*Number} options.batteryVoltage 电池电压（如电池类型选中磷酸铁锂有12V，24V，其他）
 * @param {*Number} options.batteryOverVoltage 电池超压电压（用于充电停止电压），单位：V
 * @param {*Number} options.batteryOverToBackVoltage 电池超压恢复电压，单位：V
 * @param {*Number} options.batteryLowVoltage 电池低压电压（用于停止亮灯电压），单位：V
 * @param {*Number} options.batteryLowToBackVoltage 电池低压恢复电压，单位：V
 * @param {*Number} options.ledRatedCurrent LED灯额定电流，单位：A
 * @param {*Number} options.dayThreshold 光控天亮阈值，单位：V
 * @param {*Number} options.nightThreshold 光控天黑阈值，单位：V
 */
const updateConfig = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/set-param/${options.deviceId}`, options)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 开、关、调光（批量）
 * @param {*String} msg 提示文字
 * @param {*String} deviceId 设备id
 * @param {*Number} switchState 操作类型，1-开、2-关、3-调光
 * @param {Number} brightness 亮度 调光时，需要该参数
 */
const openOrCloseOrDimme = async (msg, deviceId, switchState, brightness) => {
  AuiToast.loading({
    title: msg,
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/switch-control/${deviceId}`, { switchState, brightness })
    .then(() => new Promise(resolve => setTimeout(resolve, 8000)))
    .then(res => {
      AuiToast.hide()
      return res
    })
    .then(() => axios.get(`/api/v2/solar-motes/get-info-and-status/${deviceId}`, {}))
}
/**
 * 恒流恒压一体机非LED开、关、（批量）
 * @param {*String} msg 提示文字
 * @param {*String} deviceId 设备id
 * @param {*Number} volSwitchState 操作类型，1-开、0-关
 */
const notLEDOpenOrCloseOrDimme = async (msg, deviceId, volSwitchState) => {
  AuiToast.loading({
    title: msg,
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v1/device-downs/turn-vol-switch`, { deviceId, volSwitchState })
    .then(() => new Promise(resolve => setTimeout(resolve, 8000)))
    .then(res => {
      AuiToast.hide()
      return res
    })
    .then(() => axios.get(`/api/v2/solar-motes/get-info-and-status/${deviceId}`, {}))
}
/**
 * 光伏并网设置充电/不充电
*/
const putPowerSwitch = async (msg, projectId, moteId, type) => {
  AuiToast.loading({
    title: msg,
    duration: 2000
  }, function (ret) {})
  return axios.put(`/api/v1/solar-motes/putPowerSwitch?projectId=${projectId}`, {
    moteId,
    type
  })
    .then(() => new Promise(resolve => setTimeout(resolve, 8000)))
    .then(res => {
      AuiToast.hide()
      return res
    })
    .then(() => axios.get(`/api/v2/solar-motes/get-info-and-status/${moteId}`, {}))
}
/**
 * 4G流量开关操作
 * @param {int} fourthGenerationFlowSwitchState 4G流量开光
 * @param {int} deviceId 设备ID
*/
const switch4GState = async (deviceId, fourthGenerationFlowSwitchState, msg) => {
  AuiToast.loading({
    title: msg,
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/fourth-generation-flow-switch-control/${deviceId}`, { fourthGenerationFlowSwitchState })
    .then(() => new Promise(resolve => setTimeout(resolve, 5000)))
    .then(res => {
      AuiToast.hide()
      return res
    })
    .then(() => axios.get(`/api/v2/solar-motes/get-info-and-status/${deviceId}`, {}))
}
const fillZero = (value) => {
  return value < 10 ? `0${value}` : String(value)
}
const formatTime = (timestamp) => {
  if (!timestamp) return '--'
  const now = new Date(timestamp)

  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const date = now.getDate()
  const hours = now.getHours()
  const minutes = now.getMinutes()
  const seconds = now.getSeconds()

  return `${year}-${fillZero(month)}-${fillZero(date)}, ${fillZero(hours)}:${fillZero(minutes)}:${fillZero(seconds)}`
}
/**
 * 设置是否继续更新，防止在离开更新页面后，导致界面数据显示错误的BUG
 * @param flag
 * @returns {Promise<void>}
 */
let isContinueUpdate = true
const setContinueUpdate = async (flag) => {
  isContinueUpdate = flag
}
/**
 * 更新设备状态 后 获取设备信息和状态
 * @param {*String} deviceId 设备id
 * @param {*Number} lastTimeStamp 设备上次更新时间
 */
const updateDeviceStatus = async (deviceId, lastTimeStamp) => {
  AuiToast.loading({
    title: `${window.vm.$i18n.t('projectModule.updating')}...`,
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/get-status/${deviceId}`, {})
    .then(() => new Promise(resolve => setTimeout(resolve, 5000)))
    .then(() => axios.get(`/api/v2/solar-motes/get-info-and-status/${deviceId}`, {}))
    .then(res => {
      return new Promise(resolve => {
        if (isContinueUpdate) {
          const updateTime = res.updatedAt
          // const serverTime = Date.parse(res.header.Date || res.header.date)
          console.log('更新设备时间--', `更新时间: ${updateTime}`, `设备上次更新时间: ${lastTimeStamp}`)
          if (updateTime <= lastTimeStamp) {
            AuiToast.hide()
            AuiDialog.alert({
              title: `${window.vm.$i18n.t('projectModule.updateAgain')}`,
              msg: `${window.vm.$i18n.t('projectModule.failForUpdate')}<br>${formatTime(updateTime)}`,
              buttons: [window.vm.$i18n.t('verification.cancel'), window.vm.$i18n.t('verification.sure')]
            }, function (ret) {
              if (ret && ret.buttonIndex === 2) {
                AuiToast.loading({
                  title: `${window.vm.$i18n.t('projectModule.updating')}...`,
                  duration: 2000
                }, function (ret) {})
                updateDeviceStatus(deviceId, updateTime)
                  .then(newRes => {
                    newRes.flag = 'confirm'
                    resolve(newRes)
                  })
              } else {
                res.flag = 'cancel'
                resolve(res)
              }
            })
          } else {
            AuiToast.hide()
            res.flag = 'confirm'
            resolve(res)
          }
        } else {
          AuiToast.hide()
          res.flag = 'cancel'
          resolve({})
        }
      })
    })
    .then(res => {
      if (isContinueUpdate) {
        if (res.flag === 'confirm') {
          AuiToast.success({
            title: window.vm.$i18n.t('verification.success'),
            duration: 2000
          })
        } else {
          AuiToast.fail({
            title: window.vm.$i18n.t('verification.cancel'),
            duration: 2000
          })
        }
        return res
      }
    })
}
/**
 * 设置设备的告警为已处理(后面跟设备id)
 * @param {*String} deviceId 设备id
 */
const setDeviceNoWarn = async (deviceId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.put(`/api/v2/solar-motes/processed/${deviceId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 对设备下发策略
 * @param {*String} deviceId 设备id
 * @param {*String} strategyId 策略id
 */
const updateDeviceStrategy = async (deviceId, strategyId, type) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  let strategyTemplate = null
  if (type === '8' || type === '9') {
    strategyTemplate = { strategyTemplateIds: strategyId.split(',') }
  } else {
    strategyTemplate = { strategyTemplateId: strategyId }
  }
  return axios.post(`/api/v2/device-downs/set-strategy/${deviceId}`, strategyTemplate)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 对设备下发市电互补切换电源电压
 * @param {*String} deviceId 设备id
 * @param {*double} switchingPowerSupplyVoltage 切换电源电压(9V~15V)
 */
const setPowerSupplyVoltage = async (deviceId, switchingPowerSupplyVoltage) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/set-power-supply-voltage/${deviceId}`, { switchingPowerSupplyVoltage })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 对设备下发人流量参数
 * @param {*String} deviceId 设备id
 * @param {*int} trafficControl 人流量开关 0-关闭；1-开启
 */
const setTrafficParam = async (deviceId, trafficControl) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/set-traffic-param/${deviceId}`, { trafficControl })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 外部传感器授权
 * @param {*String} targetId 所属设备id
*/
const serverManageOauthNoTokenLogin = async () => {
  const code = 'RMKR1AN8HI'
  const timestamp = Date.now()
  const salt = 'v9ztjyyah7d1jwzrjddv'
  return axios.post(`/api/sensor/oapi/server-manage-oauth/noToken/login`, {
    code,
    timestamp,
    sign: md5(sha256(code + timestamp + salt))
  })
}
/**
 * 获取摄像头Token
 * @param {*String} targetId 所属设备id
*/
const getCameraToken = async (targetId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/sensor/oapi/camera-security/get-token-by-target-id/${targetId}`)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取摄像头信息
 * @param {*String} targetId 所属项目id
*/
const getCameraList = async (targetId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/sensor/oapi/component-camera/find-by-target-id/${targetId}`)
    .then(res => {
      AuiToast.hide()
      return res
    })
}

const device = {
  serverManageOauthNoTokenLogin,
  getCameraToken,
  getCameraList,
  getAllDevices,
  deleteDevice,
  getDeviceStatusInfor,
  getDeviceStrategyInfor,
  updateDeviceInfor,
  getDeviceWarnsById,
  getDeviceStatusById,
  getProjectDevicesBrief,
  addDevice,
  updateConfig,
  openOrCloseOrDimme,
  notLEDOpenOrCloseOrDimme,
  updateDeviceStatus,
  setDeviceNoWarn,
  updateDeviceStrategy,
  setPowerSupplyVoltage,
  setTrafficParam,
  setContinueUpdate,
  switch4GState,
  putPowerSwitch
}
export default device
